<template>
  <div>
    <vs-card>
      <vs-row class="my-4">
           <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
          >
          <label style="font-size: 18px;">{{ $t('client') }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="9"
            vs-lg="9"
          >
            <v-select
              v-model="params.client_id"
              :options="clientList"
              class="w-full"
              :reduce="(client) => client.ClientId"
              label="ClientName"
              @input="getData"
            />
          </vs-col>
        </vs-row>
    </vs-card>
    <recipient-sidebar :recipient="recipient" :clientList="clientList"/>
    <vs-card>
      <div id="recipient-table-loading" class="vs-con-loading__container">
        <vs-row>
          <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
            <recipient-table
              :data="list"
              @loadMore="loadMore"
              @search="handleSearch"
              @sort="sort"
              @edit="edit"
              @add="add"
            />
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import moduleRecipient from '@/store/recipient/moduleRecipient.js'
import RecipientTable from './components/RecipientTable'
import RecipientSidebar from './components/RecipientSidebar'
import AddButton from '@/views/components/buttons/AddButton'
import loading from '@/mixins/Loading'
import vSelect from 'vue-select'
import client from '@/http/requests/client'
export default {
  components: {
    RecipientTable,
    RecipientSidebar,
    AddButton,
    vSelect,
  },
  computed: {
    list() {
      return this.$store.state.recipient.recipientList
    },
    isLoading() {
      return this.loading.search || this.loading.client
    },
  },
  created() {
    if (!moduleRecipient.isRegistered) {
      this.$store.registerModule('recipient', moduleRecipient)
      moduleRecipient.isRegistered = true
    }
  },
  data: () => ({
    lastPage: '',
    params: {
      client_id:[],
      sortBy: ['Recipients.Name'],
      sort: ['ASC'],
    },
    clientList:[],
    search: '',
    page: 1,
    loading: {
      search: false,
      client: false,
    },
    recipient:{}
  }),
  methods: {
    getData() {
      this.loading.search = true
      let data = Object.assign({}, this.params)
      data.page = this.page
      data.search = this.search
      data.client_id = [ data.client_id ]
      this.$store
        .dispatch('recipient/fetchRecipientList', data)
        .then((res) => {
          this.lastPage = res.data.last_page
          this.loading.search = false
        })
        .catch((err) => {
          this.loading.search = false
        })
    },
    init() {
      this.getClientList()
    },
    loadMore() {
      if (this.page >= this.lastPage) {
        return
      }
      this.page++
      this.getData()
    },
    handleSearch(text) {
      this.search = text
      this.page = 1
      this.getData()
    },
    sort(e) {
      this.params.sortBy = e.sortBy
      this.params.sort = e.sort
      this.getData()
    },
    edit(recipient) {
       this.recipient = Object.assign({}, recipient)
      this.$store.dispatch('toggleSidebar', 'recipient-sidebar')
    },
    add(){
      this.recipient = Object.assign({}, null)
      this.$store.dispatch('toggleSidebar', 'recipient-sidebar')
    },
    getClientList(){
      this.loading.client = true
      client
        .list()
        .then((res) => {
          this.clientList = res.data.clients
          this.loading.client = false
          this.params.client_id = this.clientList[0].ClientId
          this.getData()
        })
        .catch((err) => {
          this.loading.client = false
        })
    }
  },
  mixins: [loading],
  mounted() {
    this.init()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`recipient-table-loading`)
      } else {
        this.closeLoading(`recipient-table-loading`)
      }
    },
  },
}
</script>

<style>
</style>